export default __webpack_public_path__ + "static/logo-christie-finance-coloured-4a6b8d1a09d704d21640b565fdf16f84.svg";